(() => {
  // After-Add-to-cart popup. When a product is added to the cart, fetches sections/ab-add-popup.liquid
  // from that product's URL and, if it has anything to offer (the tank's Aquarium Builder kit, or
  // "Customers also bought" picks), shows it as a modal (a bottom sheet on phones).
  // Adds made by the upsell blocks themselves (marked ?ab=upsell) and the builder's own
  // "Add tank + kit" (_builder_kit) don't open it, and nor does anything once the shopper picks
  // "Don't show this again" (remembered on their device).
  // The theme opens its cart drawer on every add. While we find out whether there's a popup to show,
  // the drawer is hidden; if there is, the drawer is shut and "View cart" opens it; if not, it shows as usual.
  if (window.__abPopup) return;
  window.__abPopup = 1;

  const script = document.currentScript;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  let popup = null;
  let lastFocus = null;
  let busy = false;
  let holdTimer = null;
  const OFF_KEY = 'ab-add-popup-off';

  const isOff = () => {
    try {
      return localStorage.getItem(OFF_KEY) === '1';
    } catch (e) {
      return false;
    }
  };

  const style = document.createElement('style');
  // Parts of the drawer set their own visibility when open, so hide the whole subtree with opacity.
  style.textContent = '.abp-hold .quick-cart{opacity:0!important}.abp-hold .quick-cart,.abp-hold .quick-cart *{pointer-events:none!important}';
  document.head.appendChild(style);

  const drawerOpen = () => document.querySelector('.quick-cart__wrapper.active');
  const shutDrawer = () => {
    const button = drawerOpen() && document.querySelector('.quick-cart [data-modal-close]');
    if (button) button.click();
  };
  // Keeps the drawer shut while the popup is open, including when the theme reopens it after an add.
  const drawerWatch = new MutationObserver(() => {
    if (popup && !popup.hidden) shutDrawer();
  });

  function hold() {
    document.documentElement.classList.add('abp-hold');
    clearTimeout(holdTimer);
    holdTimer = setTimeout(release, 5000);
  }

  // The drawer stays hidden while the popup is open, so it's never seen sliding shut behind it.
  function release() {
    clearTimeout(holdTimer);
    if (popup && !popup.hidden) return;
    document.documentElement.classList.remove('abp-hold');
  }

  function added(text) {
    open(handleOf(text)).then(shown => { if (!shown) release(); });
  }

  const isAdd = url => {
    try {
      const u = new URL(String(url), location.href);
      return /\/cart\/add(\.js|\.json)?$/.test(u.pathname) && !u.searchParams.has('ab');
    } catch (e) {
      return false;
    }
  };

  const isKitAdd = body => {
    if (!body) return false;
    if (typeof body === 'string') return body.includes('_builder_kit');
    if (body instanceof FormData || body instanceof URLSearchParams) {
      for (const [key] of body.entries()) if (key.includes('_builder_kit')) return true;
    }
    return false;
  };

  const handleOf = text => {
    try {
      const data = typeof text === 'string' ? JSON.parse(text) : text;
      const item = Array.isArray(data.items) ? data.items[data.items.length - 1] : data;
      return item && item.handle;
    } catch (e) {
      return null;
    }
  };

  const nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    const request = nativeFetch.apply(this, arguments);
    try {
      const url = typeof input === 'string' || input instanceof URL ? input : input && input.url;
      const method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      if (method === 'POST' && isAdd(url) && !isKitAdd(init && init.body) && !isOff()) {
        hold();
        request.then(response => {
          if (response.ok) response.clone().text().then(added).catch(release);
          else release();
        }).catch(release);
      }
    } catch (e) { /* never break the theme's own add */ }
    return request;
  };

  const xhrOpen = XMLHttpRequest.prototype.open;
  const xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__abp = String(method).toUpperCase() === 'POST' && isAdd(url);
    return xhrOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (body) {
    if (this.__abp && !isKitAdd(body) && !isOff()) {
      hold();
      this.addEventListener('loadend', () => {
        if (this.status >= 200 && this.status < 300) added(this.responseText);
        else release();
      });
    }
    return xhrSend.apply(this, arguments);
  };

  function load(tag, attr, url) {
    if (!url || document.querySelector(`${tag}[${attr}="${url}"]`)) return;
    const el = document.createElement(tag);
    if (tag === 'link') el.rel = 'stylesheet';
    el[attr] = url;
    document.head.appendChild(el);
  }

  function build() {
    popup = document.createElement('div');
    popup.className = 'abp';
    popup.hidden = true;
    popup.setAttribute('data-abp', '');
    popup.innerHTML = '<div class="abp__backdrop" data-abp-close></div>' +
      '<div class="abp__panel" role="dialog" aria-modal="true" aria-labelledby="abp-title">' +
      '<button type="button" class="abp__close" data-abp-close aria-label="Close">' +
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
      '</button><div data-abp-body></div></div>';
    document.body.appendChild(popup);
    popup.addEventListener('click', event => {
      if (event.target.closest('[data-abp-close]')) {
        close();
      } else if (event.target.closest('[data-abp-off]')) {
        try {
          localStorage.setItem(OFF_KEY, '1');
        } catch (e) { /* private browsing: just close */ }
        close();
      } else if (event.target.closest('[data-abp-cart]')) {
        const icon = document.querySelector('[data-js-cart-icon]');
        if (!icon || !document.querySelector('.quick-cart')) return;
        event.preventDefault();
        close();
        release();
        icon.click();
      }
    });
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && popup && !popup.hidden) close();
    });
    // ab-cart-upsell.js tells us when one of our picks was added.
    document.addEventListener('abp:added', event => {
      const button = event.detail && event.detail.button;
      if (!button || !popup.contains(button)) return;
      if (button.classList.contains('abu__all')) {
        close();
        return;
      }
      button.classList.remove('is-loading');
      button.classList.add('is-added');
      button.setAttribute('aria-label', 'Added');
      button.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l5 5L20 7"/></svg>';
    });
  }

  async function open(handle) {
    if (!handle || busy) return false;
    busy = true;
    try {
      const response = await nativeFetch(`${root}products/${encodeURIComponent(handle)}?sections=ab-add-popup`, {credentials: 'same-origin'});
      if (!response.ok) return false;
      const html = (await response.json())['ab-add-popup'] || '';
      if (!html.includes('data-abp-content')) return false;
      load('link', 'href', script && script.dataset.css);
      load('link', 'href', script && script.dataset.upsellCss);
      load('script', 'src', script && script.dataset.upsellJs);
      if (!popup) build();
      popup.querySelector('[data-abp-body]').innerHTML = html;
      // "Add all 5 · £X" reads "Add the Good kit · £X" here, as in the mockup.
      popup.querySelectorAll('.abu__all[data-abu-kit]').forEach(button => {
        const text = button.firstChild;
        if (text && text.nodeType === 3) text.textContent = text.textContent.replace(/^\s*Add (all \d+|it)/, `Add the ${button.dataset.abuKit} kit`);
      });
      lastFocus = document.activeElement;
      popup.hidden = false;
      document.documentElement.classList.add('abp-hold');
      shutDrawer();
      // The theme can open the drawer after this (it marks .quick-cart__wrapper active), so watch for that.
      drawerWatch.observe(document.body, {attributes: true, attributeFilter: ['class'], subtree: true});
      document.body.style.overflow = 'hidden';
      popup.querySelector('.abp__close').focus();
      return true;
    } catch (e) {
      return false;
    } finally {
      busy = false;
    }
  }

  function close() {
    if (!popup || popup.hidden) return;
    popup.hidden = true;
    drawerWatch.disconnect();
    // Let the drawer finish sliding shut before it can be seen again.
    setTimeout(release, 400);
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
})();
